import { usePowerOffice } from './PowerOffice';
import { useTripletex } from './Tripletex';
import type { PayrollSystem } from './payrollSystem';

/** Whether the company is linked to this payroll system (#187); asks only the one it is, and only when `enabled`. */
export function useConnected(sys: PayrollSystem, enabled = true) {
  const po = usePowerOffice(enabled && sys.key === 'poweroffice');
  const tx = useTripletex(enabled && sys.key === 'tripletex');
  return !!(sys.key === 'poweroffice' ? po.data?.connected : tx.data?.connected);
}
